import React from "react";
import { Col, Row } from "react-bootstrap";
import { FiCodesandbox } from "react-icons/fi";
import { SiNetlify } from "react-icons/si";
import { SiRender } from "react-icons/si";

import { DiNetbeans } from "react-icons/di";
import {
  SiVisualstudiocode,
  SiSlack,
} from "react-icons/si";

function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <SiNetlify/>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiVisualstudiocode />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <FiCodesandbox />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiRender />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiNetbeans />
      </Col>
    </Row>
  );
}

export default Toolstack;
